import React, {useContext, useState} from "react";

import {useMutation} from "@apollo/client";
import {useNavigate, useParams} from 'react-router-dom';
import FlashMessage from "../shared/FlashMessage";
import {AuthContext} from "../../context/authContext";
import {loginUserMutation} from "../users/UserQueries";
import isEmpty from "lodash/isEmpty";

const Login = () => {
  const { login } = useContext(AuthContext);
  const params = useParams()
  const navigate = useNavigate();
  const [flash, setFlash] = useState({});
  const [formState, setFormState] = useState({
    email: '',
    password: ''
  });
  const { user } = useContext(AuthContext)

  if (user) {
    navigate('/profile')
  }
  if (params.message && isEmpty(flash))
    setFlash({ type: 'success', message: params.message })

  const [loginMethod] = useMutation(loginUserMutation)

  const onSubmit = (e) => {
    // console.log(formState)
    e.preventDefault()
    loginMethod({
      variables: {
        email: formState.email,
        password: formState.password
      },
      onCompleted: ({ signinUser: data }) => {
        if (data && data.token) {
          login(data)
          navigate('/');
        } else {
          setFlash({ type: 'danger', message: 'Datele de logare nu sunt corecte' })
        }
      },
      onError: (error) => {
        setFlash({ type: 'danger', message: error.message })
      }
    });
  }

  const updateFormState = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div
      className="position-absolute top-50 start-50 translate-middle w-75 login-form bg-lighter-branding p-4 rounded shadow">
      <FlashMessage flash={flash} />
      <form>
        <h1 className="h3 mb-4 fw-normal">Autentificare</h1>
        <div className="mb-3">
          <input type="email" className="form-control border-0 border-bottom bg-white" id="floatingInput"
                 name='email' placeholder="Email" onChange={updateFormState} />
        </div>
        <div className="mb-3">
          <input type="password" className="form-control border-0 border-bottom bg-white"
                 name='password' id="floatingPassword"
                 onChange={updateFormState} />
        </div>

        {/*<div className="checkbox mb-3">*/}
        {/*  <label>*/}
        {/*    <input type="checkbox" value="remember-me"/> Remember me*/}
        {/*  </label>*/}
        {/*</div>*/}
        <button className="w-100 btn btn-lg btn-primary" type="submit" onClick={onSubmit}>Autentificare</button>
      </form>
    </div>
  )
}

export default Login
